export const APP_NAME = "TendVia";
export const SESSION_COOKIE = "tv_session";
export const OTP_TTL_SECONDS = 10 * 60;
export const SESSION_TTL_SECONDS = 30 * 24 * 60 * 60;
export const OTP_MAX_ATTEMPTS = 5;
export const OTP_RATE_LIMIT_WINDOW_SECONDS = 15 * 60;
export const OTP_EMAIL_LIMIT = 5;
export const OTP_IP_LIMIT = 12;

export const verticalKinds = [
  "auto_detailing",
  "pressure_washing",
  "junk_removal",
  "pool_cleaning",
  "airbnb_turnover",
  "handyman",
  "general"
] as const;

export const clientStatuses = ["active", "archived"] as const;
export const targetStatuses = ["active", "archived"] as const;
export const leadSourceOptions = ["text", "call", "email", "instagram", "facebook", "website form", "repeat customer", "other"] as const;
export const leadSources = [...leadSourceOptions, "manual"] as const;
export const leadConversationUrgencies = ["asap", "soon", "flexible", "unknown"] as const;
export const suggestionConfidenceLevels = ["low", "medium", "high"] as const;
export const leadStatuses = ["new", "contacted", "quoted", "scheduled", "lost", "converted"] as const;
export const jobStatuses = ["draft", "scheduled", "in_progress", "completed", "canceled"] as const;
export const jobChecklistStatuses = ["pending", "completed", "skipped"] as const;
export const quoteStatuses = ["draft", "sent", "accepted", "converted", "canceled"] as const;
export const quotePackageStatuses = ["active", "archived"] as const;
export const quoteItemTypes = ["package", "addon"] as const;
export const appointmentStatuses = ["pending", "scheduled", "completed", "canceled"] as const;
export const invoiceStatuses = ["draft", "sent", "paid", "void"] as const;
export const messageTemplateKeys = ["quote_reply", "need_more_info", "confirmation", "review_request", "rebooking_reminder"] as const;
export const messageTemplateStatuses = ["active", "archived"] as const;
export const mediaAssetGroups = ["before", "after", "damage", "marketing"] as const;
export const mediaAssetStatuses = ["active", "archived"] as const;
export const marketingContactStatuses = ["pending_review", "approved", "needs_research", "rejected", "archived"] as const;
export const outreachStatuses = [
  "not_contacted",
  "research_invite_sent",
  "research_declined",
  "research_replied",
  "interview_scheduled",
  "interview_completed",
  "beta_interest",
  "marketing_opt_in",
  "do_not_contact"
] as const;
export const consentStatuses = [
  "no_marketing_consent",
  "research_follow_up_ok",
  "beta_follow_up_ok",
  "marketing_opt_in",
  "do_not_contact"
] as const;
